import React, { useMemo } from 'react';
import { IVendorDocuments, StatusSection } from '../StatusSection';
import { Card, Grid, Header2Text, IconType, RotatingIcon } from '../../../ui-toolkit';
import { ETAForm } from './ETAForm';
import { IVendorPayoffInformationData } from '../../../types/vendorDashboard/IVendorPayoffInformation';
import { updateEtaPayoff } from '../../../store/vendorStore/vendorPayoffData/dispatch';
import { useSelector } from 'react-redux';
import { UUID } from '../../../types/shared/UUID';
import { buildIsVendorPayoffByName } from '../../../types/order/documents/IDocumentCategoryType';
import { VendorSelectors } from '../../../selectors/vendorPortal/VendorSelectors';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../API/documentCategories/DocumentCategoriesApi';
import { useAppDispatch } from '../../../store/store';

export interface IPayoffStatusAndETAProps {
  orderId: UUID;
  payoff: IVendorPayoffInformationData;
}

export const PayoffStatusAndETA: React.FC<IPayoffStatusAndETAProps> = ({ orderId, payoff }) => {
  const {
    updatePayoffFetchStatus: { fetching },
  } = useSelector(VendorSelectors.selectPayoff);
  const { documents } = useSelector(VendorSelectors.selectDocuments);
  const { data: { documentCategoriesByName } = defaultNormalizedDocumentCategoriesData } =
    useListDocumentCategoriesQuery();

  const getVendorPayoffByName = buildIsVendorPayoffByName(documentCategoriesByName);

  const requiredDocument: IVendorDocuments[] = useMemo(() => {
    const orderDocuments = documents[orderId] ?? [];
    return [
      {
        label: 'Payoff from 3rd Party Vendor',
        document: orderDocuments.find((document) => getVendorPayoffByName(document.category)),
      },
    ];
  }, [documents, getVendorPayoffByName, orderId]);

  const dispatch = useAppDispatch();
  const onUpdateEta = (value?: string | null) => {
    dispatch(updateEtaPayoff(orderId, payoff.payoffRequestId, value));
  };

  return (
    <Grid>
      <StatusSection status={payoff.status} vendorDocuments={requiredDocument} />
      <Card>
        <Grid templateColumns={'min-content min-content'}>
          <Header2Text>ETA</Header2Text>
          {fetching && <RotatingIcon type={IconType.Loading} />}
        </Grid>
        <ETAForm eta={payoff.eta} onSubmit={(eta) => onUpdateEta(eta)} readOnly={fetching} />
      </Card>
    </Grid>
  );
};
